import React, { useRef } from 'react';
import { CarData } from './CarData';

function ScrollableGallery() {
  const scrollRef = useRef(null);

  const handleWheel = (event) => {
    const container = scrollRef.current;
    if (!container || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    const canMove = event.deltaY > 0
      ? container.scrollLeft < container.scrollWidth - container.clientWidth
      : container.scrollLeft > 0;
    if (canMove) {
      event.preventDefault();
      container.scrollBy({ left: event.deltaY, behavior: 'smooth' });
    }
  };

  return (
    <section className="gallery-strip">
      <div className="content-shell">
        <div className="section-heading">
          <div><p className="eyebrow">Galeriden</p><h2 className="section-title">Daha fazlasını keşfet</h2></div>
        </div>
        <div className="scroll-container" ref={scrollRef} onWheel={handleWheel}>
          {CarData.map((car) => (
            <article className="mini-card" key={car.id}>
              <img src={car.img} alt={car.name} loading="lazy" />
              <div className="mini-card-body"><h3>{car.name}</h3><span className="mini-card-price">€{Number(car.price).toLocaleString('tr-TR')}</span></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ScrollableGallery;
